// import fixWindowsZoom from "./utils/fix-windows-zoom";

import Sharer from 'sharer.js';

import Nav from './components/nav';
import SlabMasonry from './components/masonry';
import initSliders from "./components/swiper";
import Selects from './components/selects';
import Accordions from './components/accordions';
import WishAjax from './components/wish-ajax';
import SingleSummary from './components/single-summary';
import FiltersPostsAjax from './components/filters-posts-ajax';
import SubscriptionTabs from './components/subscription-tabs';
import SubscriptionCarousel from './components/subscription-carousel';
import WordListAnim from "./components/word-list-anim";
import ContentSearchTabs from "./components/content-search";
import WooQuantity from "./woo/woo-quantity";
import PlayerPopup from './components/playerPopUp';

import './components/script.js';

/**
 * Initialise une fonction si un élément existe dans le DOM
 * @param {string} selector
 * @param {function} callback
 */
function initIf(selector, callback) {
    const el = document.querySelector(selector);
    if (el) callback(el);
}

const initScripts = () => {

    new Nav();
    new PlayerPopup();
    new WishAjax();
    new Accordions();
    new SubscriptionTabs();
    new Selects();
    new SingleSummary();
    new WooQuantity()

    initIf('.block-content-search', () => new ContentSearchTabs());
    initIf('.block-cta-subscription', () => new SubscriptionCarousel());
    initIf('.block-word-list', () => new WordListAnim());
    initIf('.block-archive-posts', (el) => {
        new FiltersPostsAjax({
            contentType: el.dataset.type || 'post'
        });
    });
    initIf('.masonry', () => new SlabMasonry());
    initIf('.swiper-wrapper', () => initSliders());

}

document.addEventListener("DOMContentLoaded", function () {
    // fixWindowsZoom();
    initScripts();
});
